/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProductFamilyQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ProductFamilyQueryOperator");
    }

    getFixupPrototypeFunction() { return ProductFamilyQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ProductFamilyQueryOperator>): ProductFamilyQueryOperator {
        let obj = Object.assign(new ProductFamilyQueryOperator(), model);
        ProductFamilyQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProductFamilyQueryOperator>): ProductFamilyQueryOperator {
        if (!model) return null;
        return ProductFamilyQueryOperator.newInstance(<ProductFamilyQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProductFamilyQueryOperator) {
        if (!obj) return;

        models.ProductFamilyQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProductFamilyQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProductFamilyQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Product families to include
     */
    product_families: Array<string>;

}
